export enum TabsStrategy {
  RouterConnected = 'routerConnected',
  Controlled = 'controlled',
  Stateful = 'stateful',
}
